import { REGULATION } from '../constants/regulation';
import RegulationHelper from './regulationHelper';

class EnvHelper {
  static instance = null;

  constructor() {
    if (EnvHelper.instance) {
      return EnvHelper.instance;
    }
    EnvHelper.instance = this;
  }

  static getInstance() {
    if (!EnvHelper.instance) {
      EnvHelper.instance = new EnvHelper();
    }
    return EnvHelper.instance;
  }

  isFSC(forceFSC = false) {
    return RegulationHelper.getInstance().getRegulationId() === REGULATION.FSC || forceFSC;
  }

  getApiUrl(forceFSC = false) {
    if (this.isFSC(forceFSC)) {
      return process.env.REACT_APP_API_URL_FSC;
    }
    return process.env.REACT_APP_API_URL;
  }

  getGrpcUrl(server = '') {
    // In development mode, use current origin to leverage webpack proxy
    if (this.isDevelopment()) {
      // Store the server info in localStorage so metadata can include it in headers
      if (server && typeof window !== 'undefined') {
        localStorage.setItem('trade.server', server);
      }
      return window.location.origin;
    }

    const grpcUrls = {
      live: process.env.REACT_APP_GRPC_LIVE,
      live1: process.env.REACT_APP_GRPC_LIVE_1,
      live2: process.env.REACT_APP_GRPC_LIVE_2,
      live3: process.env.REACT_APP_GRPC_LIVE_3,
      live4: process.env.REACT_APP_GRPC_LIVE_4,
      live5: process.env.REACT_APP_GRPC_LIVE_5,
      demo: process.env.REACT_APP_GRPC_DEMO
    };

    if (this.isFSC()) {
      const grpcUrlsFSC = {
        live: process.env.REACT_APP_GRPC_FSC_LIVE,
        demo: process.env.REACT_APP_GRPC_FSC_DEMO
      };
      return grpcUrlsFSC[server] ?? grpcUrlsFSC.live;
    }

    return grpcUrls[server];
  }

  isDevelopment() {
    return process.env.NODE_ENV === 'development';
  }

  isProduction() {
    return process.env.NODE_ENV === 'production';
  }

  /**
   * Get dynamic PUBLIC_URL based on current domain
   * Falls back to process.env.PUBLIC_URL if window is not available (SSR)
   */
  getPublicUrl() {
    if (typeof window !== 'undefined' && window.location) {
      return window.location.origin;
    }
    return process.env.PUBLIC_URL || '';
  }

  /**
   * Fix hardcoded URLs to use current origin
   * Replaces any .iux.com domain URLs with current origin
   * Always returns a string for consistency
   */
  fixUrl(url) {
    if (!url) {
      return url;
    }

    const currentOrigin = this.getPublicUrl();

    // Handle URL objects - always return string
    if (url instanceof URL) {
      if (url.href.includes('.iux.com') && url.origin !== currentOrigin) {
        const newUrl = new URL(url.pathname + url.search + url.hash, currentOrigin);
        return newUrl.href;
      }
      return url.href;
    }

    // Handle string URLs
    if (typeof url === 'string') {
      if (url.includes('.iux.com') && !url.startsWith(currentOrigin)) {
        return url.replace(/https?:\/\/[^/]+\.iux(vn)?\.com/, currentOrigin);
      }
      return url;
    }

    return url;
  }
}

export default EnvHelper;
